import React, { useState} from 'react';

// components
import DownloadButton from '../components/DownloadButton';
import CustomWoowiiTalentCompanyButton from '../components/CustomWoowiiTalentCompanyButton';
import SectionHeading from '../components/SectionHeading';
import AppFeatureSingle from '../components/AppFeatureSingle';
import Button from '../components/Button';
import PricingSlider from '../components/PricingSlider';
import TestimonialSlider from '../components/TestimonialSlider';
import ScreenSlider from '../components/ScreenSlider';
import ContactForm1 from '../components/ContactForm1';
import ContactForm2 from '../components/ContactForm2';
import BlogSingle from '../components/BlogSingle';
import WoowiiFeedbackSingle from '../components/WoowiiFeedbackSingle';
import BackgroundAnimation from '../components/BackgroundAnimation';
import VideoLightBox from '../components/VideoLightBox';

// images
import hero_phone from '../../assets/images/screens/hero-mobile.svg';
import video_img from '../../assets/images/video-img.jpg';
import background_image_1 from '../../assets/images/patterns/pattern-1.jpg';
import background_image_2 from '../../assets/images/patterns/pattern-2.jpg';
import feedback_user_1 from '../../assets/images/feedback/user-1.png';
import feedback_user_2 from '../../assets/images/feedback/user-2.png';
import feedback_user_3 from '../../assets/images/feedback/user-3.png';
import feature_phone_1 from '../../assets/images/soy-talento.svg';
import feature_image_1 from '../../assets/images/feature-section-1-img.jpg';
import feature_phone_2 from '../../assets/images/soy-empresa.svg';
import feature_image_2 from '../../assets/images/feature-section-2-img.jpg';
import icon_wand from '../../assets/images/icons/wand.svg';
import icon_speaker from '../../assets/images/icons/speaker.svg';

// data
import blog from '../data/blog';
import features from '../data/features';
import faq from '../data/faq';
import talentoData from '../data/talentoData';
import companyData from '../data/companyData';
import CustomWoowiiTalentCompanyButtonFooter from '../components/CustomWoowiiTalentCompanyButtonFooter';

const Index = () => {

    const [showFAQList, setShowFAQList] = useState(false);
    const displayedFaq = showFAQList ? faq : faq.slice(0, 6);

    return (
        <>
            {/* hero - start */}
            <div className="hero hero-1">
                <div className="hero-wrapper">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-6 offset-lg-0 order-lg-1 col-10 offset-1 order-2">
                                <div className="hero-content skip-top-padding reduced-padding c-white">
                                        <h2 class="text-inter" style={{marginBottom:"0px"}}>No todos los caminos</h2>
                                        <h1 class="text-inter" style={{lineHeight:1}}> conducen a Roma</h1>
                                    <p className="large mt-0 mb-5">¿Cansado de los ATS que fallan más que cupido en un mal día?
                                        <br></br> 
                                       <h4 className='mt-3' style={{fontWeight:"400"}}>Somos el <b class="text-color-woowii-bob">Bumble</b> del empleo, donde empresas y talentos <br></br> hacen <b class="text-color-woowii-bob">Match</b> con nuestro revolucionario algoritmo:  </h4>
                                    
                                    <h3 class="woowii-h3-mobile">APPLICANT<span class="text-color-woowii-bob">•</span>MATCHING<span class="text-color-woowii-bob">•</span>SYSTEM</h3> 
                                    ¿Listo para cambiar las reglas del juego?
                                    </p>
                                    <CustomWoowiiTalentCompanyButton buttonType='download-button-2'/>
                                    <h3 class="large woowii-hero-below-buttons" style={{fontWeight:"400"}}>El <span class="text-color-woowii-bob cursive-woowii">candidato</span> perfecto para la <span class="text-color-woowii-bob cursive-woowii">empresa</span> perfecta</h3>
                                </div>
                            </div>
                            <div className="col-lg-6 offset-lg-0 order-lg-2 col-10 offset-1 order-1">
                                <div className="hero-image">
                                    <img className="drop-shadow" src={hero_phone} alt="hero-phone" />
                                </div>
                            </div>
                        </div>
                        
                    </div>
                    <div className="background-pattern background-pattern-1">
                        <BackgroundAnimation/>
                        <div className="background-pattern-gradient woowii-background-pattern-gradient"></div>
                        <div className="background-pattern-bottom">
                            <div className="image" style={{backgroundImage: `url(${background_image_1})`}}></div>
                        </div>
                    </div>
                </div>
            </div>
            {/* hero - end */}

            {/* app feature - start */}
            <div className="app-feature app-feature-1">
                <div className="app-feature-wrapper">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12 offset-lg-0 col-10 offset-1">
                                <h2 class="text-inter text-color-woowii-electrico mb-5 woowii-mobile-title-top-section">
                                Dile adiós a los largos procesos de selección <br></br> y a la búsqueda eterna del Santo Grial
                                </h2>
                                {/* <SectionHeading
                                    // heading='app features'
                                    subHeading='Dile adiós a los largos procesos de selección y a la búsqueda eterna del Santo Grial'
                                    // icon='las la-cog'
                                    additionalClasses='center width-64'
                                /> */}
                            </div>
                        </div>
                        <div className="row gx-5 gy-5">
                            { features.map((element, key) => {
                                return (
                                    <div className="col-lg-4 offset-lg-0 col-md-6 offset-md-0 col-10 offset-1" key={key}>
                                        <AppFeatureSingle
                                            icon={element.icon}
                                            heading={element.heading}
                                            excerpt={element.excerpt}
                                            containerClass='app-feature-single-2'
                                            link={element.to}
                                        />
                                    </div>
                                );
                            }) }
                        </div>
                    </div>
                </div>
            </div>
            {/* app feature - end */}


            {/* early adopters - start */}
            <div className="video-section ">
                <div className="video-section-wrapper">
                    <div className="container woowii-early-adopters-mobile">
                        <div className="row">
                                <div className="offset-2 col-8 video-section-content">
                                    <div className="d-flex flex-column align-items-center section-heading section-heading-1 center-responsive c-white">
                                        <div className="main-heading">
                                            <h1> <span class="text-inter">Conoce la magia de ser un</span> <span style={{fontWeight:300}} class="cursive-woowii text-color-woowii-bob">Early Adopter</span><img class="ms-2" src={icon_wand}></img> </h1>
                                        </div>
                                        <p class="text-inter">
                                        ¡Únete a la <b class="text-color-woowii-bob">Waiting List</b> y disfruta de beneficios exclusivos: perfil destacado, 
                                        <br></br>acceso anticipado a nuevas funciones, <b class="text-color-woowii-bob">Wiibucks</b> y soporte premium!
                                        <br></br>¡Sé embajador de por vida y marca la diferencia!
                                        </p>
                                    </div>
                                        <div class="mt-5 d-flex align-items-center justify-content-center woowii-early-adopter-button-mobile">
                                            <Button
                                                to="/waiting-list-form"
                                                content="UNIRME A LA WAITING LIST"
                                                type="button-1"
                                            />
                                            <p class="ms-5 text-inter text-color-woowii-bob">
                                            ¿A qué esperas?
                                            </p>
                                        </div>
                                </div>
                        </div>
                        <div className="background-pattern background-pattern-radius drop-shadow-1 w-100">
                            <BackgroundAnimation/>
                            <div className="background-pattern-gradient woowii-pink-background-pattern-gradient"></div>
                        </div>
                    </div>
                </div>
            </div>
            {/* early adopters - end */}

            {/* feature section - start */}
            <div className="feature-section feature-section-0 feature-section-spacing-1" id="talento-section-id">
                <div className="feature-section-wrapper">
                    <div className="container">
                        <div className="row gx-5">
                            <div className="col-lg-12 offset-lg-0 order-lg-1 col-md-12 offset-md-2 col-10 offset-1 order-2">
                                <h2 style={{color:"black"}}>
                                ¡Somos el Bumble del empleo!<br></br> No pierdas más tiempo en búsquedas sin respuestas, <br></br>dile adiós a tu CV, evita sesgos y califica a las empresas.
                                </h2>
                            </div>
                            <div className="col-lg-7 offset-lg-0 order-lg-1 col-md-8 offset-md-2 col-10 offset-1 order-2">
                                <div className="feature-section-content">
                                    <h4 class="d-flex p-2 text-color-woowii-bob text-inter" style={{backgroundColor:"black", width:"fit-content"}}>¡Brilla como un faro en medio del océano!</h4>
                                        {/* faq section - start */}
                                        <div  className="faq-section">
                                            <div className="faq-section-wrapper">
                                                <div className="container">
                                                    <div className="row d-flex justify-content-center">
                                                        <div className="col-12">
                                                            <div className="">
                                                                <div className="faq" id="faq-accordion-talent">
                                                                    {
                                                                        talentoData.map((element, key) => {
                                                                            return (
                                                                                <div className="accordion-item" key={key}>
                                                                                    <div className="accordion-header" id={`faq-talent-${key}`}>
                                                                                        <button
                                                                                        style={{color:"black"}}
                                                                                        className={`accordion-button woowii-accordion-button ${ 'collapsed'}`}
                                                                                        type="button" 
                                                                                        data-bs-toggle="collapse" 
                                                                                        data-bs-target={`#faq-talent-collapse-${key}`} 
                                                                                        aria-expanded={'false'}
                                                                                        aria-controls={`faq-talent-collapse-${key}`}>
                                                                                            <span>{element.question}</span>
                                                                                        </button>
                                                                                    </div>
                                                                                    <div 
                                                                                    id={`faq-talent-collapse-${key}`} 
                                                                                    className={`accordion-collapse collapse ${ ''}`}
                                                                                    aria-labelledby={`faq-talent-${key}`} 
                                                                                    data-bs-parent="#faq-accordion-talent">
                                                                                        <div className="accordion-body">
                                                                                            <p>{element.answer}</p>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            );
                                                                        })
                                                                    }
                                                                                                        <div>
                                                                                                            <Button
                                                                                                                
                                                                                                                to="/waiting-list-form"
                                                                                                                content="¡QUIERO SER PARTE!"
                                                                                                                type="button-2 w-100 text-center woowii-center-button text-color-black"
                                                                                                            />
                                                                                                        </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {/* faq section - end */}


             
                                </div>
                            </div>
                            <div className="col-lg-5 offset-lg-0 order-lg-2 col-10 offset-1 order-1 mt-2">
                                <div className="feature-section-image">
                                    <img src={feature_phone_1} className="phone" alt="phone" />
                                 
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* feature section - end */}

                        {/* feature section - start */}
                        <div className="feature-section feature-section-0 feature-section-spacing-1" id="company-section-id">
                <div className="feature-section-wrapper">
                    <div className="container">
                        <div className="row gx-5">
                            <div className="col-lg-12 offset-lg-0 order-lg-1 col-md-12 offset-md-2 col-10 offset-1 order-2">
                                <h2 style={{color:"black"}}>
                                ¡Consigue el match perfecto para tu equipo! Pero sin el ghosting habitual, potenciando tu Employer Branding.
                                </h2>
                            </div>
                            <div className="col-lg-7 offset-lg-0 order-lg-1 col-md-8 offset-md-2 col-10 offset-1 order-2">
                                <div className="feature-section-content">
                                    <h4 class="d-flex p-2 text-inter bg-color-woowii-electrico" style={{color:"white", width:"fit-content"}}>¡Y asegúrate de tener más fans que Taylor Swift!</h4>
                                        {/* faq section - start */}
                                        <div  className="faq-section">
                                            <div className="faq-section-wrapper">
                                                <div className="container">
                                                    <div className="row d-flex justify-content-center">
                                                        <div className="col-12">
                                                            <div className="">
                                                                <div className="faq" id="faq-company-accordion">
                                                                    {
                                                                        companyData.map((element, key) => {
                                                                            return (
                                                                                <div className="accordion-item" key={key}>
                                                                                    <div className="accordion-header" id={`faq-company-${key}`}>
                                                                                        <button
                                                                                        style={{color:"black"}}
                                                                                        className={`accordion-button ${'collapsed'}`}
                                                                                        type="button" 
                                                                                        data-bs-toggle="collapse" 
                                                                                        data-bs-target={`#faq-company-collapse-${key}`} 
                                                                                        aria-expanded={'false'}
                                                                                        aria-controls={`faq-company-collapse-${key}`}>
                                                                                            <span>{element.question}</span>
                                                                                        </button>
                                                                                    </div>
                                                                                    <div 
                                                                                    id={`faq-company-collapse-${key}`} 
                                                                                    className={`accordion-collapse collapse ${ ''}`}
                                                                                    aria-labelledby={`faq-company-${key}`} 
                                                                                    data-bs-parent="#faq-company-accordion">
                                                                                        <div className="accordion-body">
                                                                                            <p>{element.answer}</p>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            );
                                                                        })
                                                                    }

                                                                     <div>
                                                                        <Button
                                                                            
                                                                            to="/request-demo"
                                                                            content="SOLICITAR DEMO"
                                                                            type="button-3 w-100 text-center woowii-center-button"
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {/* faq section - end */}


                                </div>
                            </div>
                            <div className="col-lg-5 offset-lg-0 order-lg-2 col-10 offset-1 order-1 mt-2">
                                <div className="feature-section-image">
                                    <img src={feature_phone_2} className="phone" alt="phone" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* feature section - end */}

            

            {/* pricing section - start */}
            <div className="pricing-section" id="testimonials-section-id">
                <div className="pricing-section-wrapper">
                    <div className="container">
                        <div className="row mb-5">
                            <div className="col-lg-12 offset-lg-0 col-md-8 offset-md-2 col-10 offset-1">
                                <SectionHeading
                                    // icon='las la-tags'
                                    // heading='our app rates'
                                    subHeading='LO QUE SE DICE DE NOSOTROS EN LOS PASILLOS DE LAS REDES'
                                    additionalClasses='center c-white'
                                    mainHeadingClass='c-white text-start'
                                    subHeadingClass='c-white'
                                    subHeadingIconSrc={icon_speaker}
                                />
                            </div>
                        </div>
                        {/* <PricingSlider/> */}
                        <div className="pricing row gx-5">
                            {
                                blog.slice(0, 3).map((element, key) => {
                                    return (
                                        <div key={key} className="col-lg-4 offset-lg-0 col-md-8 offset-md-2 col-10 offset-1">
                                            <WoowiiFeedbackSingle element={element} />
                                        </div>
                                    );
                                })
                            }
                        </div>

                    </div>
                    <div className="background-pattern background-pattern-1">
                        <BackgroundAnimation/>
                        <div className="background-pattern-gradient"></div>
                        <div className="background-pattern-bottom">
                            <div className="image" style={{backgroundImage: `url(${background_image_1})`}}></div>
                        </div>
                    </div>
                </div>
            </div>
            {/* pricing section - end */}


            {/* faq section - start */}
            <div id="faq-section-id" className="faq-section mt-5">
                <div className="faq-section-wrapper mt-5">
                    <div className="container">
                        <div className="row">
                            <div className="col-xxl-12  col-lg-12 col-12 ">
                                <div class="text-color-woowii-popeye text-inter d-flex flex-column align-items-center mb-5">
                                <h1 style={{lineHeight:1, paddingTop:"15rem"}}>Preguntas curiosas,<br></br>respuestas ingeniosas.</h1>
                                </div>
                            </div>
                        </div>
                        <div className="row d-flex justify-content-center">
                            <div className="col-lg-9 col-md-8 col-10">
                                <div className="faq-wrapper">
                                    <div className="faq" id="faq-accordion">
                                        {
                                            displayedFaq.map((element, key) => {
                                                return (
                                                    <div className="accordion-item" key={key}>
                                                        <div className="accordion-header" id={`faq-${key}`}>
                                                            <button
                                                            style={{color:"black"}}
                                                            className={`accordion-button ${'collapsed'}`}
                                                            type="button" 
                                                            data-bs-toggle="collapse" 
                                                            data-bs-target={`#faq-collapse-${key}`} 
                                                            aria-expanded={'false'}
                                                            aria-controls={`faq-collapse-${key}`}>
                                                                <span>{element.question}</span>
                                                            </button>
                                                        </div>
                                                        <div 
                                                        id={`faq-collapse-${key}`} 
                                                        className={`accordion-collapse collapse ${''}`}
                                                        aria-labelledby={`faq-${key}`} 
                                                        data-bs-parent="#faq-accordion">
                                                            <div className="accordion-body">
                                                                <p>{element.answer}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                );
                                            })
                                        }
                                        <div class="d-flex align-items-center justify-content-center mt-5 pt-1">
                                            {!showFAQList && <a class="button button-2" style={{cursor:"pointer"}} onClick={() => setShowFAQList(true)}>
                                                <div class="button-inner woowii-button-inner">
                                                    <div class="button-content">
                                                        <h4 class="ps-5 pe-5">Mostrar Más</h4>
                                                    </div>
                                                </div>
                                            </a>}
                                            {showFAQList && <a class="button button-2" style={{cursor:"pointer"}} onClick={() => setShowFAQList(false)}>
                                                <div class="button-inner woowii-button-inner">
                                                    <div class="button-content">
                                                        <h4 class="ps-5 pe-5">Ocultar</h4>
                                                    </div>
                                                </div>
                                            </a>}
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* faq section - end */}

            {/* team section - start */}
            <div id="team-section-id" className="testimonial-section">
                <div className="testimonial-section-wrapper">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12 offset-lg-0 col-md-8 offset-md-2 col-10 offset-1">
                                <h2 class="cursive-woowii text-color-woowii-electrico mb-5" style={{textAlign:"center", fontWeight:300}}>El Team que cambió la historia :</h2>
                            </div>
                        </div>
                    </div>
                    <div className="container">
                        <div className="row">
                            <TestimonialSlider/>
                        </div>
                    </div>
                </div>
            </div>
            {/* team section - end */}



            {/* screen section - start */}
            <div className="screen-section">
                <div className="screen-section-wrapper">
                    <ScreenSlider/>
                    {/* screen section bottom - start */}
                    <div className="screen-section-bottom">
                        <div className="screen-section-bottom-wrapper">
                            <div className="container">
                                <div className="row">
                                    <div className="col-lg-8 offset-lg-0 col-10 offset-1">
                                        <h1 className="c-white" style={{lineHeight:1}}>Se parte de la transformación de los recursos humanos:</h1>
                                        {/* <h4 className="c-white">
                                            <i className="fas fa-smile" style={{marginRight: '1rem'}}></i>
                                            3 Million users and counting!
                                        </h4> */}
                                    </div>
                                    <div className="col-lg-4 offset-lg-0 col-10 offset-1">
                                        <CustomWoowiiTalentCompanyButtonFooter buttonType='download-button-2'/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* screen section bottom - end */}     
                </div>
                <div className="background-pattern background-pattern-2">
                    <BackgroundAnimation/>
                    <div className="background-pattern-gradient"></div>
                    <div className="background-pattern-bottom">
                        <div className="image" style={{backgroundImage: `url(${background_image_2})`}}></div>
                    </div>
                </div>
            </div>
            {/* screem section - end */}


            {/* cta section - start */}
            {/* <div className="cta-section">
                <div className="cta-section-wrapper">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12 offset-lg-0 col-md-8 offset-md-2 col-10 offset-1">
                                <SectionHeading
                                    icon='las la-cloud-download-alt'
                                    heading='Download Orions'
                                    subHeading='Join Orions and get 20% off on your selected plan.'
                                    additionalClasses='center width-71'
                                />
                                <DownloadButton color='c-white'/>
                            </div>
                        </div>
                    </div>
                </div>
            </div> */}
            {/* cta section - end */}

            {/* contact form section - start */}
            {/* <div className="contact-form-section contact-form-section-1">
                <div className="contact-form-section-wrapper">
                    <div className="container">
                        <div className="row gx-5 contact-form-section-row">
                            <div className="col-lg-6 offset-lg-0 col-md-8 offset-md-2 col-10 offset-1">
                                <ContactForm1/>
                            </div>
                            <div className="col-lg-6 offset-lg-0 col-md-8 offset-md-2 col-10 offset-1">
                                <ContactForm2/>
                            </div>
                        </div>
                    </div>
                </div>
            </div> */}
            {/* contact form section - end */}
        </>
    );
};

export default Index;
